
<script lang="ts">
  import { LoginScreen, Page, List, LoginScreenTitle, ListInput, BlockFooter, ListButton, f7 } from "framework7-svelte";
  import { importTokenStore } from "../stores/import-token.store";
  import { getOldLisaProjectList } from "../api/imports.api";

  let username: string;
  let password: string;

  let opened = false;
  let loginFailed = false;

  async function signIn() {
    try {
      const token = btoa(`${username}:${password}`)
      await getOldLisaProjectList(token);
      importTokenStore.set(token);
    }
    catch (error) {
      loginFailed = true;
      return;
    }

    loginFailed = false;
    f7.loginScreen.close();
    f7.views.main.router.navigate('/import');
  }

  function signOut() {
    importTokenStore.set(null);
  }
</script>
<LoginScreen
    id="login-screen"
    opened={opened}
    onLoginScreenClosed={() => {
      opened = false;
    }}>
  <Page loginScreen>
    <LoginScreenTitle>{$importTokenStore ? 'Uitloggen bij oude Lisa' : 'Inloggen bij oude Lisa'}</LoginScreenTitle>
    {#if $importTokenStore && !loginFailed}
      <div>
        <span>Je bent ingelogd op de Oude Lisa.</span>
      </div>
    <List form>
      <ListButton onClick={signOut}>Uitloggen</ListButton>
      <ListButton loginScreenClose="#login-screen">Terug</ListButton>
    </List>
    {:else}
      <div>
        <span>Vul de gebruikersnaam en het wachtwoord in van een van de accounts voor de oude Lisa applicatie om te importen.</span>
      </div>
    <List form>
      <ListInput
        label="Gebruikersnaam"
        type="text"
        placeholder="Je gebruikersnaam"
        value={username}
        onInput={(e) => (username = e.target.value)}
      />
      <ListInput
        label="Password"
        type="password"
        placeholder="Your password"
        value={password} 
        onInput={(e) => (password = e.target.value)}
      />
    </List>
      {#if loginFailed}
        <div>
          <span>Gebruikersnaam en/of wachtwoord incorrect. Probeer het opnieuw.</span>
        </div>
      {/if}
    <List inset>
      <ListButton class={!username ? 'disabled' : undefined} onClick={signIn}>Inloggen</ListButton>
      <ListButton loginScreenClose="#login-screen">Terug</ListButton>
    </List>
    <BlockFooter>
    </BlockFooter>
    {/if}
  </Page>
</LoginScreen>

<style>
  span {
    width: max-content;
    display: block;
    margin: 0 auto;
  }
</style>